// English source strings of unknown external effects (decision D41-B2, PRD AC08): the panel where an organization admin
// records what happened on the remote system. Merged into `en`; pt-BR lives in pt-BR-operations.ts (complete, checked by
// the type).
export const enOperations = {
  "operations.title": "Unknown external effects",
  "operations.intro": "These actions reached an external system, but no outcome was recorded. They are never repeated on their own.",
  "operations.introAdmin": "Check the remote system, then record what happened: it happened (with its reference, when you have one) or it did not happen.",
  "operations.readOnlyNotice": "An organization administrator must decide. You can see what is waiting, but only an administrator can record the outcome.",
  "operations.loadFailed": "Could not load the unknown external effects",
  "operations.emptyTitle": "Nothing waiting for a decision",
  "operations.emptyBody": "No external effect in this project has an unknown outcome.",
  "operations.col.operation": "Operation",
  "operations.col.destination": "Destination",
  "operations.col.requested": "Requested",
  "operations.col.decision": "Decision",
  "operations.noDestination": "Not recorded",
  "operations.happened": "It happened",
  "operations.didNotHappen": "It did not happen",
  "operations.happenedFor": "It happened: {operation}",
  "operations.didNotHappenFor": "It did not happen: {operation}",
  "operations.dialog.happenedTitle": "Record that it happened",
  "operations.dialog.didNotHappenTitle": "Record that it did not happen",
  "operations.dialog.happenedBody": "Confirm only after you checked the remote system and found the effect there. The operation is closed and will not run again.",
  "operations.dialog.didNotHappenBody": "Confirm only after you checked the remote system and found no trace of the effect. It will be performed once on the next run.",
  "operations.note": "What you checked",
  "operations.noteHint": "Where you looked, for example the branch, the pull request list or the deployment page. Stored with the decision.",
  "operations.providerRef": "Provider reference",
  "operations.providerRefHint": "Pull request number, commit SHA or deployment id, when you know it.",
  "operations.confirmHappened": "Confirm: it happened",
  "operations.confirmDidNotHappen": "Confirm: it did not happen",
  "operations.resolvedDone": "Recorded as done: {operation}.",
  "operations.resolvedNotDone": "Recorded as not done: {operation}. It will run once on the next run.",
  "operations.kind.gitCommit": "Create commit",
  "operations.kind.gitPush": "Push commits",
  "operations.kind.gitPushPublish": "Publish code (push)",
  "operations.kind.gitIntegrate": "Integrate branch",
  "operations.kind.prCreate": "Open pull request",
  "operations.kind.githubRepositoryCreate": "Create GitHub repository",
  "operations.kind.githubDeployKeyAdd": "Add deploy key on GitHub",
  "operations.kind.coolifyAppCreate": "Create app in Coolify",
  "operations.kind.coolifyKeyCreate": "Create key in Coolify",
  "operations.kind.coolifyDeploy": "Deploy in Coolify",
};
